import React from "react";
import Line from "../../../assets/line2.svg";
import MainImg from "../../../assets/illustrations2/PNG/homepage_verified_leads.png";
// import { FaCheck } from "react-icons/fa";
import check from "../../../assets/check.svg";

export default function TestimonialTwo() {
  return (
    <div className="bg-white px-8 pt-12 pb-6 lg:pb-0 flex flex-col md:flex-row md:items-center md:justify-between">
      <div className="flex justify-center items-center my-8 md:mt-0 md:w-[45%] md:order-2">
        <img src={MainImg} alt="Dashboard preview" className="md:w-full w-96" />
      </div>
      <div className="text-left md:w-[55%] md:order-1 md:p-6">
        <h2 className="text-3xl text-[#15223F] sm:text-4xl lg:text-[2.5rem] lg:leading-[3.75rem] font-bold">
          Only Pay for What{" "}
          <span className="relative inline-block">
            Works
            <img
              src={Line}
              alt="Underline decoration"
              className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
            />
          </span>{" "}
        </h2>
        <p className="text-xl md:text-[22px] my-4">
          We believe in keeping things fair and simple:
        </p>
        <p className="text-xl md:text-[22px] my-4">
          Every email passes strict verification to guarantee delivery rates
          over 97%.
        </p>
        <p className="text-xl md:text-[22px] my-4">
          Use them confidently in your campaigns to reach more people and
          protect your sending reputation.
        </p>
        <ul className="text-xl md:text-2xl my-4 space-y-5 font-semibold">
          <li className="flex items-center">
            {/* <FaCheck className="text-[#4F7FFF] mr-6 text-xl mt-1" /> */}
            <img
              src={check}
              alt="Checkmark"
              className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
            />
            Searched for the same email twice? It's on us!{" "}
          </li>
          <li className="flex items-center">
            {/* <FaCheck className="text-[#4F7FFF] mr-6 text-xl mt-1" /> */}
            <img
              src={check}
              alt="Checkmark"
              className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
            />
            Partially verified emails? They're free too
          </li>
          <li className="flex items-center">
            {/* <FaCheck className="text-[#4f7fff] mr-6 text-xl mt-1" /> */}
            <img
              src={check}
              alt="Checkmark"
              className="mr-3 -ml-3 -mt-[1px] w-12 h-12"
            />
            Couldn't find an email? No charge
          </li>
        </ul>
      </div>
    </div>
  );
}
